// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */
import React from "react";
import { i18next } from "@translations/invenio_app_rdm/i18next";
import { DashboardSearchLayoutHOC } from "@js/invenio_app_rdm/user_dashboard/base";
import { RDMEmptyResults as RDMNoSearchResults } from "@js/invenio_app_rdm/search/components";
import { Button, Divider, Header, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";

export const RDMEmptyResults = (props) => {
    const { queryString } = props;
    return queryString === "" ? (
      <Segment.Group>
        <Segment placeholder textAlign="center" padded="very">
          <Header as="h1" align="center">
            <Header.Content>
              {i18next.t("Get started!")}
              <Header.Subheader>{i18next.t("Make your first upload in your community!")}</Header.Subheader>
            </Header.Content>
          </Header>
          <Divider hidden />
          <Button
            positive
            floated="right"
            href="/communities/galenos-data"
            content={i18next.t("My community")}
          />
        </Segment>
      </Segment.Group>
    ) : (
      <Segment padded="very">
        <RDMNoSearchResults {...props} searchPath="/me/uploads" />
      </Segment>
    );
  };

  RDMEmptyResults.propTypes = {
    queryString: PropTypes.string.isRequired,
  };

export const DashboardUploadsSearchLayout = DashboardSearchLayoutHOC({
  searchBarPlaceholder: i18next.t("Search in my uploads..."),
  appName: 'InvenioAppRdm.DashboardUploads',
});

export const DashboardCommunitiesSearchLayout = DashboardSearchLayoutHOC({
    searchBarPlaceholder: i18next.t("Search in my communities..."),
    appName: 'InvenioAppRdm.DashboardCommunities',
  });

export const overriddenComponents = {
    ['InvenioAppRdm.DashboardUploads.SearchApp.layout']: DashboardUploadsSearchLayout,
    ['InvenioAppRdm.DashboardUploads.EmptyResults.element']: RDMEmptyResults,
    ['InvenioAppRdm.DashboardCommunities.SearchApp.layout']: DashboardCommunitiesSearchLayout,
}
